import React, { useEffect, useState } from 'react';
import { useTheme } from '../../context/ThemeContext';
import {
  recordBedtimePromptNeverAsk,
  recordBedtimePromptShownToday,
  shouldOfferBedtimeDarkPrompt,
} from '../../utils/bedtimeDarkPrompt';
import './BedtimeDarkPrompt.css';

/**
 * Gentle evening suggestion to switch to dark mode (hub landing).
 * @param {{ enabled?: boolean }} props — set false to skip (e.g. non-hub routes).
 */
export default function BedtimeDarkPrompt({ enabled = true }) {
  const { darkMode, setDarkMode } = useTheme();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!enabled || darkMode) {
      setOpen(false);
      return;
    }
    if (shouldOfferBedtimeDarkPrompt({ darkMode })) {
      setOpen(true);
    }
  }, [enabled, darkMode]);

  if (!open) return null;

  const close = () => setOpen(false);

  const handleNotNow = () => {
    recordBedtimePromptShownToday();
    close();
  };

  const handleNeverAsk = () => {
    recordBedtimePromptNeverAsk();
    recordBedtimePromptShownToday();
    close();
  };

  const handleSwitchToDark = () => {
    setDarkMode(true);
    recordBedtimePromptShownToday();
    close();
  };

  const handleOverlayClick = () => {
    handleNotNow();
  };

  return (
    <div
      className="bedtime-prompt-overlay"
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="bedtime-prompt-title"
    >
      <div
        className="bedtime-prompt-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="bedtime-prompt-title">Winding down?</h2>
        <p>Dark mode is easier on the eyes at night. Switch now?</p>
        <div className="bedtime-prompt-actions">
          <button
            type="button"
            className="bedtime-prompt-actions__primary"
            onClick={handleSwitchToDark}
          >
            Switch to dark
          </button>
          <button type="button" onClick={handleNotNow}>
            Not now
          </button>
          <button
            type="button"
            className="bedtime-prompt-actions__quiet"
            onClick={handleNeverAsk}
          >
            Don&apos;t ask again
          </button>
        </div>
      </div>
    </div>
  );
}
